// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#backDrop[data-v-167be87c]{width:100%;height:100%;position:fixed;top:0;left:0;background:hsla(0,0%,100%,.3);z-index:999}#backDrop img[data-v-167be87c]{width:13.333vw;height:13.333vw;position:absolute;top:0;left:0;right:0;bottom:0;margin:auto}", ""]);
// Exports
module.exports = exports;
